import { gql } from '@apollo/client';

/**
 * Get current GPS locations for all active users (for real-time map view)
 */
export const GET_CURRENT_GPS_LOCATIONS = gql`
  query GetCurrentGPSLocations {
    currentGPSLocations {
      userId
      latitude
      longitude
      accuracy
      deviceType
      appState
      updatedAt
      user {
        id
        firstName
        lastName
        role
      }
    }
  }
`;

/**
 * Today's field technician map locations from job status GPS
 */
export const GET_TODAY_FIELD_TECHNICIAN_MAP_LOCATIONS = gql`
  query GetTodayFieldTechnicianMapLocations {
    todayFieldTechnicianMapLocations {
      userId
      latitude
      longitude
      accuracy
      updatedAt
      locationType
      label
      jobId
      workOrderId
      activityType
      user {
        id
        firstName
        lastName
        role
      }
    }
  }
`;
